const config = {
 STUDIO_VERSION:'9daa24e1a54ef028a621ad01c56c66fb8285708d',
  NAME: 'prod',
  TRACKING_ID: '',
  API_URL: 'https://services.goodmaps.io/graphql',
};

export default config;
